import React from 'react';
import { useSelector } from 'react-redux';
import { getExtremasBounds, getPointsExtremas } from 'app/core/markers/utils';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { Edit } from './Edit';
const createHandles = (marker) => marker.points.reduce((accum, point, index) => {
    accum[`p${index}`] = {
        current: {
            x: marker.x + point.x,
            y: marker.y + point.y,
        },
    };
    return accum;
}, {});
export const EditPolyline = () => {
    const marker = useSelector(state => {
        const project = getProjectState(state);
        const selectedItemId = project.selection[0];
        if (!selectedItemId) {
            return undefined;
        }
        return project.markers[selectedItemId];
    });
    const dispatch = useAppDispatch();
    const onHandleChanged = React.useCallback((handleId, point, _downPoint, initial) => {
        if (!marker) {
            return;
        }
        let patch;
        const { id } = marker;
        const pointIndex = Number.parseInt(handleId.substring(1), 10);
        if (pointIndex > 0 && pointIndex < marker.points.length) {
            const points = [...marker.points];
            points[pointIndex] = {
                x: point.virtual.x - marker.x,
                y: point.virtual.y - marker.y,
            };
            patch = {
                id,
                patch: {
                    bbox: getExtremasBounds(getPointsExtremas(points)),
                    points: [...points],
                },
            };
        }
        if (patch) {
            dispatch(ProjectActions.itemUpdate(Object.assign(Object.assign({}, patch), { undoable: initial })));
        }
    }, [marker, dispatch]);
    return (React.createElement(Edit, { handles: createHandles(marker), onHandleChanged: onHandleChanged }));
};
